import { extra_resource_book_constant } from "./constants";


export const listExtraResourceBook = (returnedPayload) => ({
  type: extra_resource_book_constant.GET_RESOURCE_BOOK,
  payload: returnedPayload,
});
export const deleteExtraResourceBook = (returnedPayload) => ({
  type: extra_resource_book_constant.DELETE_RESOURCE_BOOK,
  payload: returnedPayload,
});
